module.exports = __webpack_public_path__ + "img/HPS010CP.a80c6933.png";